var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.38841 2.40374C2.2917 1.2494 3.65372 0.5 5.41667 0.5C7.61909 0.5 8.99068 1.49335 10 2.44673C11.0093 1.49335 12.3809 0.5 14.5833 0.5C16.3463 0.5 17.7083 1.2494 18.6116 2.40374C19.4989 3.5376 19.9167 5.023 19.9167 6.5C19.9167 9.06708 18.4078 11.3147 16.5257 13.0613C14.6316 14.819 12.2557 16.1698 10.2742 16.9481C10.0979 17.0173 9.90206 17.0173 9.72582 16.9481C7.74432 16.1698 5.3684 14.819 3.47431 13.0613C1.59218 11.3147 0.0833359 9.06708 0.0833359 6.5C0.0833359 5.023 0.501145 3.5376 1.38841 2.40374ZM2.56972 3.32814C1.92928 4.14657 1.58334 5.28617 1.58334 6.5C1.58334 8.46375 2.74825 10.3411 4.49465 11.9618C6.14366 13.4921 8.22017 14.7053 10 15.4414C11.7798 14.7053 13.8563 13.4921 15.5054 11.9618C17.2518 10.3411 18.4167 8.46375 18.4167 6.5C18.4167 5.28617 18.0707 4.14657 17.4303 3.32814C16.8059 2.53018 15.8762 2 14.5833 2C12.6164 2 11.552 2.99475 10.5339 4.02672C10.393 4.16958 10.2007 4.25 10 4.25C9.79933 4.25 9.60702 4.16958 9.46609 4.02672C8.44802 2.99475 7.38357 2 5.41667 2C4.12379 2 3.19414 2.53018 2.56972 3.32814Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTask);
export default __webpack_public_path__ + "static/media/new-task.c3205308e8996d9b73a7f088669be240.svg";
export { ForwardRef as ReactComponent };